import { useCreativeTemplatesBuilderStore } from 'stores/CreativeTemplatesBuilderStore';

export const useAlmFrame = () => {
  const store = useCreativeTemplatesBuilderStore();

  return { store };
};
